import React from "react";
import "./ArticleEditListItem.css";
import Draggable from "react-draggable";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import { generateUniqueID } from "../../utils/utils";
import { connect } from "react-redux";
import { getACSTypesForACDType, getACSTypeBg } from "../../model/ACSTypeUtil";
import {
  setACDItemAction,
  setLockingIDAction,
  deleteContentAction,
  saveArticleAction,
  createManualItemAction
} from "../../redux/actions/editArticlePanel";
import { toast } from "react-toastify";
import { setMediaUsedAction } from "../../redux/actions/pdfEditArticleAVList";
import ArticleEditTextListItem from "../ArticleEditTextListItem/ArticleEditTextListItem";
import ArticleEditSepListItem from "../ArticleEditSepListItem/ArticleEditSepListItem";
import ArticleEditImageListItem from "../ArticleEditImageListItem/ArticleEditImageListItem";
import ArticleEditVideoListItem from "../ArticleEditVideoListItem/ArticleEditVideoListItem";
import ArticleEditAudioListItem from "../ArticleEditAudioListItem/ArticleEditAudioListItem";
import ArticleEditImageArrListItem from "../ArticleEditImageArrListItem/ArticleEditImageArrListItem";
import {
  ACDTYPE_TEXT,
  ACDTYPE_TEXT_ONLY,
  ACDTYPE_IMAGE,
  ACDTYPE_VIDEO,
  ACDTYPE_AUDIO,
  ACDTYPE_SEPARATOR,
  ACDTYPE_IMAGE_ARR
} from "../../model/ACDTypes";

class ArticleEditListItem extends React.Component {
  constructor(props) {
    super(props);

    this.handleStartDrag = this.handleStartDrag.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
    this.handleStopDrag = this.handleStopDrag.bind(this);
    this.acsTypeSelected = this.acsTypeSelected.bind(this);
    this.getCardTop = this.getCardTop.bind(this);
    this.deleteClicked = this.deleteClicked.bind(this);
    this.lockClicked = this.lockClicked.bind(this);
    this.createClicked = this.createClicked.bind(this);
    this.lastClickBtn = 0;

    this.state = {
      style: { zIndex: 0 },
      position: { x: 0, y: 0 },
      isMoving: false,
      startScrollY: null
    };
  }

  acsTypeSelected(acsType) {
    const {
      item,
      itemID,
      setACDItemAction,
      saveArticleAction,
      articleID
    } = this.props;

    if (item == null || item.styleType === acsType) {
      return;
    }

    const newItem = { ...item };
    newItem.styleType = acsType;

    setACDItemAction({
      mode: "edit",
      id: itemID,
      item: newItem
    });
    saveArticleAction(articleID);
  }

  createClicked(aCDType) {
    const {
      index,
      saveArticleAction,
      createManualItemAction,
      articleID,
      setLockingIDAction
    } = this.props;

    let insertIndex = index;

    if (insertIndex == null || isNaN(insertIndex) || index < 0) {
      return;
    }

    let imageID = "";
    if (aCDType === ACDTYPE_IMAGE) {
      imageID = prompt("Please enter Image ID", "");

      if (!imageID) {
        return;
      }

      if (imageID.length < 10) {
        toast.error("Invalid image ID");
        return;
      }
    }

    let newID = generateUniqueID();
    createManualItemAction({
      newID,
      insertIndex: insertIndex + 1,
      type: aCDType,
      imageID
    });

    setLockingIDAction({ lockingID: newID });
    saveArticleAction(articleID);
  }

  lockClicked() {
    const { itemID, lockingID, setLockingIDAction, subLockingID } = this.props;

    if (lockingID === itemID) {
      if (subLockingID == null) {
        setLockingIDAction({ lockingID: null });
      } else {
        setLockingIDAction({ lockingID: itemID });
      }
    } else {
      setLockingIDAction({ lockingID: itemID });
    }
  }

  deleteClicked() {
    const {
      itemID,
      item,
      deleteContentAction,
      saveArticleAction,
      articleID,
      setMediaUsedAction
    } = this.props;

    if (item.dataType === ACDTYPE_VIDEO || item.dataType === ACDTYPE_AUDIO) {
      setMediaUsedAction({ mediaID: item.media.id, articleID: null });
    }

    if (item.dataType === ACDTYPE_IMAGE_ARR) {
      for (let i = 0; i < item.imageItemArr.length; i++) {
        const imageItem = item.imageItemArr[i];

        if (imageItem.dataType === ACDTYPE_VIDEO) {
          setMediaUsedAction({ mediaID: imageItem.media.id, articleID: null });
        }
      }
    }

    deleteContentAction({ id: itemID, canRecover: true });
    saveArticleAction(articleID);
  }

  handleStartDrag(e) {
    const { getPanelPosition, updateScrollTop } = this.props;

    updateScrollTop();

    this.setState({
      style: { zIndex: 100 },
      isMoving: true,
      startScrollY: getPanelPosition().scrollTop
    });
  }

  handleDrag(e) {
    const { getPanelPosition, setCurDragY } = this.props;

    const newY = getRelXY(e, getPanelPosition()).y;

    if (this.lastFireY == null || Math.abs(newY - this.lastFireY) > 10) {
      setCurDragY(newY);
      this.lastFireY = newY;
      this.setState({});
    }
  }

  async handleStopDrag(e) {
    const { mergeItem, setCurDragY, item } = this.props;

    const concatOnly = this.lastClickBtn === 2;
    const mergeOK = await mergeItem(item.id, concatOnly);

    setCurDragY(-1);

    if (mergeOK) {
      return;
    }

    this.setState({
      style: { zIndex: 0 },
      position: { x: 0, y: 0 },
      isMoving: false,
      startScrollY: null
    });
  }

  renderSwitch() {
    const { itemID, item, getPanelPosition, articleID } = this.props;

    switch (item.dataType) {
      case ACDTYPE_TEXT:
        return (
          <ArticleEditTextListItem
            articleID={articleID}
            itemID={itemID}
            item={item}
          />
        );
      case ACDTYPE_TEXT_ONLY:
        return (
          <ArticleEditTextListItem
            articleID={articleID}
            itemID={itemID}
            item={item}
          />
        );
      case ACDTYPE_IMAGE:
        return (
          <ArticleEditImageListItem
            articleID={articleID}
            itemID={itemID}
            item={item}
          />
        );
      case ACDTYPE_VIDEO:
        return (
          <ArticleEditVideoListItem
            articleID={articleID}
            itemID={itemID}
            item={item}
          />
        );
      case ACDTYPE_AUDIO:
        return (
          <ArticleEditAudioListItem
            articleID={articleID}
            itemID={itemID}
            item={item}
          />
        );
      case ACDTYPE_SEPARATOR:
        return (
          <ArticleEditSepListItem
            articleID={articleID}
            itemID={itemID}
            item={item}
          />
        );
      case ACDTYPE_IMAGE_ARR:
        return (
          <ArticleEditImageArrListItem
            articleID={articleID}
            itemID={itemID}
            item={item}
            getCardTop={this.getCardTop}
            getPanelPosition={getPanelPosition}
          />
        );
      default:
        return null;
    }
  }

  getCardTop() {
    if (this.props.forwardRef.current != null) {
      return this.props.forwardRef.current.offsetTop;
    }
  }

  renderCard() {
    const { style, isMoving } = this.state;

    const {
      itemID,
      item,
      shouldHighlight,
      lockingID,
      index,
      subLockingID
    } = this.props;

    let isLocking = itemID === lockingID;

    if (
      item.dataType === ACDTYPE_IMAGE_ARR &&
      isLocking &&
      subLockingID != null
    ) {
      isLocking = false;
    }

    const highlight = !isMoving && (shouldHighlight || isLocking);

    const acsTypes = getACSTypesForACDType(item.dataType);
    const showAcsDropdown = acsTypes.length > 1;

    const headBg = getACSTypeBg(item.styleType);

    return (
      <Card
        text="dark"
        bg={highlight ? "warning" : null}
        style={style}
        className="toc_list_card"
        ref={this.props.forwardRef}
      >
        <Card.Header
          onContextMenu={e => e.preventDefault()}
          className="toc_handle"
          style={{
            backgroundColor: highlight ? null : headBg,
            paddingLeft: "10px",
            paddingTop: "5px",
            paddingBottom: "5px"
          }}
        >
          <span className="toc_order_number">{index + 1}. </span>
          {showAcsDropdown ? (
            <Dropdown
              as="span"
              onToggle={open =>
                this.setState({ style: { zIndex: open ? 10 : 0 } })
              }
              className="acs_type_dropdown cancel_move"
            >
              <Dropdown.Toggle size="sm">{item.styleType}</Dropdown.Toggle>
              <Dropdown.Menu>
                {acsTypes.map(acsType => (
                  <Dropdown.Item
                    key={acsType}
                    onClick={() => this.acsTypeSelected(acsType)}
                  >
                    {acsType}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <span className="toc_order_number">{acsTypes[0]}</span>
          )}

          <Button
            variant={isLocking ? "primary" : "secondary"}
            size="sm"
            className="toc_delete_btn cancel_move"
            onClick={this.lockClicked}
          >
            <span className="fa fa-lock" />
          </Button>
          <Dropdown
            as="span"
            alignRight
            size="sm"
            className="toc_delete_btn cancel_move"
            onToggle={open =>
              this.setState({ style: { zIndex: open ? 10 : 0 } })
            }
          >
            <Dropdown.Toggle style={{ margin: 0 }} size="sm" variant="warning">
              <span className="fa fa-plus" />
            </Dropdown.Toggle>

            <Dropdown.Menu size="sm">
              <Dropdown.Item onClick={() => this.createClicked(ACDTYPE_TEXT)}>
                Empty Card
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => this.createClicked(ACDTYPE_SEPARATOR)}
              >
                Separator
              </Dropdown.Item>
              <Dropdown.Item onClick={() => this.createClicked(ACDTYPE_IMAGE)}>
                Image ID
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <Button
            variant="danger"
            size="sm"
            className="toc_delete_btn cancel_move"
            onClick={this.deleteClicked}
          >
            <span className="fa fa-trash" />
          </Button>
        </Card.Header>
        {this.renderSwitch()}
      </Card>
    );
  }

  render() {
    const { item, getPanelPosition } = this.props;

    const { position, startScrollY } = this.state;

    const yOffset =
      startScrollY == null ? 0 : getPanelPosition().scrollTop - startScrollY;

    return (
      item && (
        <Draggable
          allowAnyClick={true}
          onMouseDown={e => {
            this.lastClickBtn = e.button;
          }}
          handle=".toc_handle"
          cancel=".cancel_move"
          position={position}
          positionOffset={{ x: 0, y: yOffset }}
          onStart={this.handleStartDrag}
          onDrag={this.handleDrag}
          onStop={this.handleStopDrag}
        >
          {this.renderCard()}
        </Draggable>
      )
    );
  }
}

function getRelXY(e, panelPosition) {
  const mousePosition = getClientPos(e);

  return {
    x: mousePosition.x - panelPosition.x,
    y: mousePosition.y - panelPosition.y + panelPosition.scrollTop
  };
}

function getClientPos(e) {
  let clientX;
  let clientY;

  if (e.touches) {
    [{ clientX, clientY }] = e.touches;
  } else {
    ({ clientX, clientY } = e);
  }

  return {
    x: clientX,
    y: clientY
  };
}

const mapState = (state, ownProps) => {
  const { editArticlePanel } = state;
  const { contentEditHistory } = editArticlePanel;

  let item = null;

  if (contentEditHistory.length > 0) {
    item =
      contentEditHistory[contentEditHistory.length - 1].itemsDict[
        ownProps.itemID
      ];
  }

  return {
    item,
    lockingID: editArticlePanel.lockingID,
    subLockingID: editArticlePanel.subLockingID
  };
};

const mapDispatch = {
  setACDItemAction,
  setLockingIDAction,
  deleteContentAction,
  saveArticleAction,
  createManualItemAction,
  setMediaUsedAction
};

export default connect(
  mapState,
  mapDispatch
)(ArticleEditListItem);
